export default __webpack_public_path__ + "static/media/3.44ddc2b8.jpg";